import { AnvaPackage, AnvaQuote } from '@flows/src/types/anva';
import { useMutation, useQuery, UseQueryOptions } from 'react-query';
import { ErrorResponse } from '../../../../../types/API';
import { wgApi } from '../../../../app/src/features/api/wgApi';

interface Params {
  sessionId?: string;
  queryOptions?: UseQueryOptions<AnvaQuotesResponse>;
}

export type AnvaQuotesResponse = {
  quotes: AnvaQuote[];
  packages: AnvaPackage[];
};

export interface AnvaQuotesPayload {
  chosen_insurance_packages?: {
    name: string;
    code: string;
    due_date?: string;
    payment_interval?: string;
    chosen_insurance_policies: {
      anva_product_id: string;
      index: number;
      coverages: number[];
    }[];
  }[];
  chosen_insurance_policies?: {
    anva_product_id: string;
    index: number;
    coverages: number[];
    due_date?: string;
    payment_interval?: string;
  }[];
}

export const getAnvaQuotes = async (
  sessionId: string,
  payload?: AnvaQuotesPayload,
) => {
  const { data, isError } = await wgApi.post<AnvaQuotesResponse>(
    `/v1/api/anvaflows/${sessionId}/calculate`,
    payload,
  );
  if (isError) throw new Error(JSON.stringify(data as ErrorResponse));
  return data;
};

export const getUseAnvaQuotesQKey = (sessionId: string) => [
  'flow-products',
  'anva',
  'quotes',
  sessionId,
];

export const useAnvaQuotes = ({ sessionId, queryOptions }: Params) => {
  return useQuery<AnvaQuotesResponse>(
    getUseAnvaQuotesQKey(sessionId!),
    () => getAnvaQuotes(sessionId!),
    {
      refetchOnMount: false,
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!sessionId,
      ...queryOptions,
    },
  );
};

export const useAnvaQuotesCalculate = () => {
  return useMutation<
    AnvaQuotesResponse,
    unknown,
    { sessionId: string; payload: AnvaQuotesPayload }
  >(({ sessionId, payload }) => getAnvaQuotes(sessionId, payload));
};
